/**
 * Created by Marcus Zhao on 8/27/19.
 * Description: add calendarDialog option for Create/Edit Calendar Event
 *
 * ------ maintenance history ------
 *  update by marcus 6/23/2021 add onblur for first name and last name change.
 */

import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { AppState } from '../../../../redux';
import { Store } from '@ngrx/store';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { ContactTemplateType, ControlId, NameAction } from '../../../contact-dialog-new/contact-dialog.model';
import { businessConstants } from '../../../../constants/business.constants';

@Component({
    selector: 'tam-contact-input',
    templateUrl: './contact-input.component.html',
    styleUrls: ['./contact-input.component.scss'],
    standalone: false
})
export class ContactInputComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input() childConfig: any;
    @Input() valueChangeSubject: Subject<ContactTemplateControlValue>;
    @ViewChild('inputTextFiled', { static: false }) inputBox: ElementRef;

    config: any;
    inputValue = '';
    hintContent: string;
    isShowPrimary: boolean;
    primaryDetail: string;
    clickable: boolean;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
    ) { }

    ngOnInit() {
        this._initData();
        if (this.config.action === ContactTemplateType.EditContact) {
            this._initEditValue();

        } else if (this.config.action === ContactTemplateType.NewContact) {
            if (this.config.isSignature) {
                this._initEditValue();
            } else {
                this.inputValue = this.config.defaultValue;
                this.changeValueSet(false);
            }
        }
        this.changeValueSet(false);
    }

    ngAfterViewInit() {
        // set firstName on focus
        setTimeout(() => {
            if (this.config.controlID === ControlId.FirstName) {
                this.inputBox.nativeElement.focus();
            }
        });
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    onBlur() {
        if (this.config.controlID === ControlId.FirstName || this.config.controlID === ControlId.LastName) {
            this._contactTemplateService.actionSubject$.next({
                type: NameAction.ChangeNameValue,
                payload: {
                    value: this.inputValue,
                    controlId: this.config.controlID,
                    prefix: this.config.prefixId
                }
            });
        }
    }

    /**
     * input value change trigger
     *
     * @param {*} value
     * @memberof ContactInputComponent
     */
    textChange(value) {
        this.hintContent = '';
        this.inputValue = value;
        this._contactTemplateService.changeValueStatus = true;
        this.changeValueSet(true);
    }

    /**
     *
     *
     * @private
     * @memberof ContactInputComponent
     */
    private _initData() {
        this.config = this.childConfig.config;
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId) {
                    if (!this.inputValue && this.config.isRequired) {
                        this.hintContent = businessConstants.tip;
                    } else if (this.inputValue && this.inputValue.indexOf(',') > -1) {
                        if (this.config.controlID === 'FirstName') {
                            this.hintContent = 'FirstName could not contain comma!';
                        } else if (this.config.controlID === 'LastName') {
                            this.hintContent = 'LastName could not contain comma!';
                        }
                    } else {
                        this.hintContent = null;
                    }
                }
            }));
    }


    /**
     *init edit value
     *
     * @private
     * @memberof ContactInputComponent
     */
    private _initEditValue() {
        this.inputValue = this.config.editValue;
        this.changeValueSet(false);
    }

    /**
     * set input control value to store or valuechangeSubject
     *
     * @param {boolean} isFromUser
     * @memberof ContactInputComponent
     */
    changeValueSet(isFromUser: boolean) {
        if (!this.inputValue) {
            this.inputValue = '';
        }
        const value = new ContactTemplateControlValue(this.inputValue, this.config.componentType, this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }
}
